import React, {CSSProperties, Fragment} from 'react';
type ActionIconProps = {
  width: string;
  height: string;
  fill: string;
  style: CSSProperties;
  title?: string
  onClick: ()=>void;
}
export const LaunchIcon = ({width, height, fill, style, onClick}: ActionIconProps) => {
  return <Fragment>
    <svg onClick={onClick} version="1.1" id="launch-instance" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 14 14" fill={fill ? fill : '#595959'} width={width} height={height} style={style}>
      <title>Launch Instance</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1125.000000, -263.000000)">
          <g id="forward"
             transform="translate(1132.000000, 270.000000) rotate(-90.000000) translate(-1132.000000, -270.000000) translate(1125.000000, 263.000000)">
            <path id="Path" className="st0" d="M0.9,7.9h9.6L6,12.4c-0.4,0.4-0.4,1,0,1.3c0.4,0.4,1,0.4,1.3,0L14,7l-1.3-1.3L7.3,0.3
              c-0.4-0.4-1-0.4-1.3,0c-0.4,0.4-0.4,1,0,1.3l4.5,4.5H0.9C0.4,6.1,0,6.5,0,7l0,0C0,7.5,0.4,7.9,0.9,7.9z"/>
          </g>
        </g>
      </g>
    </svg>
  </Fragment>;
};

export const EditIcon = ({width, height, fill, style, onClick}: ActionIconProps) => {
  return <>
    <svg onClick={onClick} version="1.1" id="edit-entities" x="0px" y="0px"
         viewBox="0 0 14 14" style={style} fill={fill} width={width} height={height}>
      <title>Edit Entities</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1152.000000, -263.000000)">
          <g id="write" transform="translate(1152.000000, 263.000000)">
            <polygon id="Path" className="st0" points="3.9,8.3 3.9,10.1 5.7,10.1 			"/>
            <path id="Path_1_" className="st0"
                  d="M13.8,1.2l-1-1c-0.2-0.2-0.5-0.2-0.7,0l-0.5,0.5l1.8,1.7l0.5-0.5C14.1,1.7,14.1,1.4,13.8,1.2z"
            />
            <polygon id="Path_2_" className="st0" points="4.4,7.9 6.1,9.6 12.9,2.9 11.2,1.1 			"/>
            <polygon id="Path_3_" className="st0" points="10.9,12.7 1.3,12.7 1.3,3.1 7.3,3.1 8.6,1.8 0,1.8 0,14 12.2,14 12.2,5.4 10.9,6.7
            "/>
          </g>
        </g>
      </g>
    </svg>
  </>;
};

export const ReTrackIcon = ({width, height, fill, style, title, onClick}: ActionIconProps) => {
  return <>
    <svg onClick={onClick} version="1.1" id="run-re-track" x="0px" y="0px"
         viewBox="0 0 15 15" fill={fill} width={width} height={height} style={style} >
      <title>{title? title:'Run Re-track'}</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1178.000000, -263.000000)">
          <g id="football-helmet" transform="translate(1178.000000, 263.000000)">
            <path id="Shape" className="st0" d="M14.1,9.6h-3.6L10,7.3l4-0.5c0.3,0,0.5-0.3,0.4-0.6c-0.7-3.8-4.2-6.6-8.2-6.1
              C3.1,0.5,0.5,3.2,0.1,6.5c-0.3,2.2,0.3,4.3,1.5,5.8c0.1,0.1,0.2,0.2,0.4,0.2h1.6L6,13.9c0.7,0.4,1.6,0.2,2.2-0.4
              c1.1-1.1,0.3-2.5,0.1-3h1.3L9.9,12c0.3,1.5,1.4,2.6,2.8,2.8C14,15,14,15,14.1,15c0.7,0,0.9-0.6,0.9-1v-3.4
              C15,10,14.6,9.6,14.1,9.6z M5.2,10.8c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7S5.5,10.8,5.2,10.8z M8,9.6L7.7,8.8
              C7.5,8.2,7.9,7.5,8.5,7.5L9,7.4l0.4,2.2H8z M14.1,14l-1.2-0.2c-0.8-0.1-1.4-0.6-1.8-1.3h3V14z M14.1,11.6h-3.3l-0.2-1h3.5V11.6z"
            />
          </g>
        </g>
      </g>
    </svg>
  </>;
};

export const BallIcon = ({width, height, fill, style, onClick}:ActionIconProps) => {
  return <>
    <svg onClick={onClick} version="1.1" id="ball-icon" x="0px" y="0px"
         viewBox="0 0 15 15" style={style} fill={fill} width={width} height={height}>
      <title>Run Ballflight Re-track</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1207.000000, -263.000000)">
          <g id="football-ball" transform="translate(1207.000000, 263.000000)">
            <path id="Shape" className="st0" d="M14.6,1.6c-0.1-0.6-0.6-1-1.1-1.1C12.7,0.3,11.6,0,10.3,0L15,4.7C15,3.4,14.8,2.3,14.6,1.6z
              M0.4,13.4c0.1,0.6,0.6,1,1.1,1.1C2.3,14.7,3.4,15,4.7,15L0,10.3C0,11.6,0.2,12.7,0.4,13.4z M0.1,8.3l6.5,6.6
              c4-0.6,7.5-3.6,8.2-8.2L8.3,0.1C4.3,0.7,0.8,3.7,0.1,8.3z M9.7,4.6c0.1-0.1,0.2-0.1,0.3,0l0.3,0.3c0.1,0.1,0.1,0.2,0,0.3L9.6,6.1
              L10.4,7c0.1,0.1,0.1,0.2,0,0.3l-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0L8.9,6.8L8.2,7.5L9,8.4c0.1,0.1,0.1,0.2,0,0.3L8.7,9
              C8.6,9.1,8.4,9.1,8.4,9L7.5,8.2L6.8,8.9l0.9,0.9c0.1,0.1,0.1,0.2,0,0.3l-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0L6.1,9.6l-0.9,0.9
              c-0.1,0.1-0.2,0.1-0.3,0l-0.3-0.3c-0.1-0.1-0.1-0.2,0-0.3l0.9-0.9L4.6,8c-0.1-0.1-0.1-0.2,0-0.3l0.3-0.3c0.1-0.1,0.2-0.1,0.3,0
              l0.9,0.9l0.7-0.7L6,6.6C5.9,6.6,5.9,6.4,6,6.3L6.3,6c0.1-0.1,0.2-0.1,0.3,0l0.9,0.9l0.7-0.7L7.3,5.3C7.2,5.2,7.2,5,7.3,4.9
              l0.3-0.3c0.1-0.1,0.2-0.1,0.3,0l0.9,0.9L9.7,4.6L9.7,4.6z"/>
          </g>
        </g>
      </g>
    </svg>

  </>;
};

export const CheckIcon = ({width, height, fill, style, onClick}: ActionIconProps) => {
  return <>
    <svg onClick={onClick} version="1.1" id="check-icon" x="0px" y="0px"
         viewBox="0 0 16 15" style={style} width={width} height={height} fill={fill}>
      <title>Save Schedule</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1236.000000, -263.000000)">
          <g id="check_box" transform="translate(1236.500000, 263.000000)">
            <path id="Shape" className="st0" d="M5.9,11.5L2.3,8l1.2-1.2l2.3,2.3l5.6-5.6l1.2,1.2L5.9,11.5z M15,0v15H0V0H15z M13.6,1.4H1.4v12.2
              h12.2V1.4z"/>
          </g>
        </g>
      </g>
    </svg>
  </>;
};

export const CancelIcon = ({width, height, fill, style, onClick}: ActionIconProps) => {
  return <>
    <svg onClick={onClick} version="1.1" id="cancel-icon" x="0px" y="0px"
         viewBox="0 0 15 15" style={style} fill={fill} width={width} height={height}>
      <title>Terminate instance</title>
      <desc>Created with Sketch.</desc>
      <g id="UI-Command-Center-User">
        <g id="Data-Ops" transform="translate(-1266.000000, -263.000000)">
          <g id="cancel_box" transform="translate(1266.000000, 263.000000)">
            <path id="Shape" className="st0" d="M2.8,11l3.5-3.5L2.8,4L4,2.8l3.5,3.5L11,2.8L12.2,4L8.7,7.5l3.5,3.5L11,12.2L7.5,8.7L4,12.2
              L2.8,11z M15,0v15H0V0H15z M13.6,1.4H1.4v12.2h12.2V1.4z"/>
          </g>
        </g>
      </g>
    </svg>
  </>;
};

export const ProgressIcon = ({color}:{color:string}) => {
  return <div style={{width: '8px', height: '8px', background: color, borderRadius: '50%', marginRight: '3px'}}/>;
};
